import { render, staticRenderFns } from "./CollectionDetails.vue?vue&type=template&id=382e5585&scoped=true&"
import script from "./CollectionDetails.vue?vue&type=script&lang=js&"
export * from "./CollectionDetails.vue?vue&type=script&lang=js&"
import style0 from "./CollectionDetails.vue?vue&type=style&index=0&id=382e5585&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382e5585",
  null
  
)

export default component.exports